import { BookingListFilterValue } from '@common/interfaces/booking-list/booking-list.interface';
import { ErrorCommonInfo } from '@lib/interfaces';

export interface BookingListState extends BookingListFilterValue {
  /** エラーメッセージID */
  errorMessageList?: ErrorCommonInfo[];
}

export const BOOKING_LIST_STORE_NAME = 'bookingList';

export interface BookingListStore {
  [BOOKING_LIST_STORE_NAME]: BookingListState;
}
